import React, { useState } from 'react';

import FolderTree from '~/components/Shared/FolderTree/FolderTree';
import { Button } from '~/eds/src/components/Button/Button';
import { Icon } from '~/eds/src/components/Icon/Icon';
import { useIntl } from 'react-intl';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Text from '~/ui/components/Text/Text';
import { useModalSimple } from '~/ui/hooks/modal';

function ArchiveLocationPath({
  folderId,
  onChange,
  errorMessage,
  // connected
  folderPath,
}) {
  const intl = useIntl();
  const [selectedItemId, setSelectedItemId] = useState(folderId);

  const [modal, showModal] = useModalSimple({
    disableAutoHide: true,
    title: intl.formatMessage({
      id: 'ArchiveLocationPath.modalTitle',
      defaultMessage: 'Choose Folder for Archive Location',
      description: 'Title for folder selection modal',
    }),
    text: intl.formatMessage({
      id: 'ArchiveLocationPath.modalText',
      defaultMessage: 'Choose Folder',
      description: 'Text for folder selection modal',
    }),
    confirm: () => onChange(selectedItemId),
    content: (
      <FlexLayout sx={{ height: '320px' }}>
        <FolderTree
          selectedItemId={selectedItemId}
          setSelectedItemId={setSelectedItemId}
        />
      </FlexLayout>
    ),
  });

  const placeholder = (
    <Text color="gray-600" sx={{ fontStyle: 'italic' }}>
      {intl.formatMessage({
        id: 'ArchiveLocationPath.selectFolderPlaceholder',
        defaultMessage: 'Select a folder',
        description: 'Placeholder text for folder selection',
      })}
    </Text>
  );

  return (
    <FlexLayout flexDirection="column" space={2}>
      <Text variant="xs-dense-caps">
        {intl.formatMessage({
          id: 'ArchiveLocationPath.destinationLabel',
          defaultMessage: 'Destination',
          description: 'Label for destination folder',
        })}
      </Text>
      <FlexLayout
        id="workflow--settings-naming-format"
        alignItems="center"
        justifyContent="space-between"
        px={4}
        py={1}
        space={4}
        sx={{
          bg: 'gray-100',
          border: 'border',
          borderRadius: 'm',
          height: 'input-height',
          borderColor: errorMessage ? 'red-400' : 'gray-200',
        }}
        onClick={showModal}
      >
        <FlexLayout space={2}>
          <Icon icon="folder" />
          <Text variant="s-spaced">
            {(folderPath && folderPath[folderId]) || placeholder}
          </Text>
        </FlexLayout>
        <Button
          id="workflow--settings-pick-folder"
          text={intl.formatMessage({
            id: 'ArchiveLocationPath.clickToPickButton',
            defaultMessage: 'Click to pick folder',
            description: 'Button text for picking a folder',
          })}
          variant="action"
          onClick={showModal}
        />
      </FlexLayout>
      {errorMessage && (
        <Text mt={2} color="red-600" variant="2xs-dense">
          {errorMessage}
        </Text>
      )}
      {modal}
    </FlexLayout>
  );
}

export default ArchiveLocationPath;
